var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.couponLoading)?_c('Loader'):_vm._e(),_c('SnackBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }